export default __webpack_public_path__ + "static/media/visa-icon.11bd1f38.svg";